var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Link, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showNotification } from '../../../redux/commonSlice';
import { getListAPI, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import CardView from '../../proprietaryWarranty/pages/proprietaryCardView';
import { jciFilterPagingAPI } from '../services/apiCall';
import { JobCardInvoicesKeys, ValidateJCInvoiceURL } from '../services/entity';
export var ReadyForInvoiceTab = function (props) {
    var _getLocalStorageItem;
    var value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'Ready-for-invoiced' : _a, disabled = props.disabled;
    console.log('value-------For Ready for', value);
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var listVariants = ["My Job Card Invoice", "All Job Card Invoice"];
    var _b = useState(listVariants.length > 0 && isAllViewActive ? listVariants[0] : listVariants[1]), selectedListVariant = _b[0], setSelectedListVariant = _b[1];
    var branch = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches.map(function (it) { return it === null || it === void 0 ? void 0 : it.OrganizationId; });
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var pagingColumns = [{
            field: 'JobCardNo',
            headerName: 'Job card no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobCardNo ? "".concat(row === null || row === void 0 ? void 0 : row.JobCardNo) : '-'; },
            minWidth: 175
        }, {
            field: 'JobCardDate',
            headerName: 'Job card date',
            valueFormatter: function (val, row) {
                var jobCardDate = row !== null && row !== void 0 && row.JobCardDate ? dayjs(row === null || row === void 0 ? void 0 : row.JobCardDate).format('DD MMM, YYYY') : '-';
                return jobCardDate;
            },
            minWidth: 175
        }, {
            field: 'EstimateDeliveryDateTime',
            headerName: 'Expt.delivery and time',
            valueFormatter: function (val, row) {
                var deliveryDate = row !== null && row !== void 0 && row.EstimateDeliveryDateTime ? dayjs(row === null || row === void 0 ? void 0 : row.EstimateDeliveryDateTime).format('DD MMM, YYYY - hh:mm a') : '-';
                return deliveryDate;
            },
            minWidth: 175
        }, {
            field: 'CustomerName',
            headerName: 'Customer name',
            valueFormatter: function (val, row) {
                var _row$Customer, _row$Customer2;
                return row !== null && row !== void 0 && (_row$Customer = row.Customer) !== null && _row$Customer !== void 0 && _row$Customer.GivenName ? "".concat(row === null || row === void 0 || (_row$Customer2 = row.Customer) === null || _row$Customer2 === void 0 ? void 0 : _row$Customer2.GivenName) : '-';
            },
            minWidth: 175
        }, {
            field: 'MobileNo',
            headerName: 'Mobile no.',
            valueFormatter: function (val, row) {
                var _row$Customer3, _row$Customer4;
                return row !== null && row !== void 0 && (_row$Customer3 = row.Customer) !== null && _row$Customer3 !== void 0 && _row$Customer3.MobileNumber ? "".concat(row === null || row === void 0 || (_row$Customer4 = row.Customer) === null || _row$Customer4 === void 0 ? void 0 : _row$Customer4.MobileNumber) : '-';
            },
            minWidth: 175
        }, {
            field: 'RegistrationNo',
            headerName: 'Registration no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RegistrationNo ? "".concat(row === null || row === void 0 ? void 0 : row.RegistrationNo) : '-'; },
            minWidth: 175
        }, {
            field: 'ServiceType',
            headerName: 'Service  type',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RepairTypeName ? "".concat(row === null || row === void 0 ? void 0 : row.RepairTypeName) : '-'; },
            minWidth: 175
        }, {
            field: 'actions',
            headerName: 'Actions',
            width: 175,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (_ref) {
                var _this = this;
                var row = _ref.row;
                return /*#__PURE__*/ React.createElement(Link, {
                    fontWeight: 'medium',
                    underline: "none",
                    component: 'button',
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var _res$payload, _res$payload2, res, _res$payload3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(getListAPI({
                                        key: JobCardInvoicesKeys.ValidateJCInvoice,
                                        url: ValidateJCInvoiceURL,
                                        request: {
                                            JobCardId: row === null || row === void 0 ? void 0 : row.JobCardId
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success && (res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.value) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.statusCode) === 200) {
                                        dispatch(setState({
                                            key: "signature",
                                            value: ""
                                        }));
                                        navigate("/create-invoice/".concat(row === null || row === void 0 ? void 0 : row.JobCardId));
                                    }
                                    else {
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: "".concat(res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.value) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.message),
                                            type: "error"
                                        }));
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, "Generate Invoice");
            }
        }];
    return isMobile ? /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        isReadyForInvoiceTitle: true,
        isGrandTotalButton: true,
        isMenuIcon: false,
        isExpandButton: true,
        pagingApiCall: jciFilterPagingAPI,
        pagingKey: JobCardInvoicesKeys.JCIFilterPagingKey,
        pagingRequest: {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
            Branches: branch,
            Status: ["ReadyForInvoice"],
            PagingFor: "Job Card",
            take: 10,
            skip: 0
        },
        pageSize: 20,
        cardMapper: function (data) {
            var _data$Customer, _data$Customer2, _dayjs;
            return {
                id: "card-".concat(data.id),
                docNo: data.RegistrationNo,
                title: data === null || data === void 0 ? void 0 : data.ProductName,
                statusName: data === null || data === void 0 ? void 0 : data.StatusName,
                details: [{
                        label: "Job Card No :",
                        value: data === null || data === void 0 ? void 0 : data.JobCardNo
                    }, {
                        label: "Customer :",
                        value: "".concat((data === null || data === void 0 || (_data$Customer = data.Customer) === null || _data$Customer === void 0 ? void 0 : _data$Customer.GivenName) || "", " ").concat((data === null || data === void 0 || (_data$Customer2 = data.Customer) === null || _data$Customer2 === void 0 ? void 0 : _data$Customer2.FamilyName) || "").trim()
                    }, {
                        label: "Service Type :",
                        value: data === null || data === void 0 ? void 0 : data.RepairTypeName
                    }, {
                        label: "Est deliver date and time:",
                        value: (_dayjs = dayjs(data === null || data === void 0 ? void 0 : data.DeliveryDate)) === null || _dayjs === void 0 ? void 0 : _dayjs.format('DD MMM, YYYY - hh:mm a')
                    }, {
                        label: "RFI date and time:",
                        value: data === null || data === void 0 ? void 0 : data.ServiceAdvisor
                    }]
            };
        },
        menuIcons: true
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "ReadyForInvoice"),
        getPagingData: jciFilterPagingAPI,
        pagingAPIRequest: _objectSpread(_objectSpread({}, !((value === null || value === void 0 ? void 0 : value.IdentityId) === 'all') && {
            IdentityId: value.IdentityId
        }), {}, {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
            PagingFor: "Job Card",
            Branches: branch,
            Status: ["ReadyForInvoice"]
        }),
        columns: pagingColumns
    })));
};
export default ReadyForInvoiceTab;
